<nes-dialog
  [active]="isServicesDialogActive$ | async"
  (nesOnCloseClick)="closeDialog()"
>
  <div slot="content">
    <h2 class="services-dialog-title">{{ 'COMPOSE.CHOOSE_EXTRAS.SERVICES.OPEN_TITLE' | translate }}</h2>
    <p class="nes-mb-5">
      {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.OPEN_EXPLAINER" | translate }}
    </p>

    <div id="services" class="nes-mt-5 services-options-border">
      <ng-container
        *ngFor="
          let service of (selectedProduct$ | async)?.services;
          trackBy: trackByIdentifier
        "
      >
        <bca-product-service
          (selected)="onServiceSelected(service, $event)"
          [service]="service"
        >
        </bca-product-service>
      </ng-container>
    </div>
  </div>
  <div class="nes-flex nes-justify-start" slot="button-group-footer">
    <nes-button
      variant="primary"
      type="button"
      (nesOnClick)="closeDialog()"
    >
      {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.SAVE" | translate }}
    </nes-button>
    <nes-button
      variant="tertiary"
      class="nes-ml-3"
      type="button"
      (click)="closeDialog()"
    >
      {{ "COMPOSE.ROUTE.BUTTON.CANCEL" | translate }}
    </nes-button>
  </div>
</nes-dialog>
